
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import {getMetaTags} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'OrganizationIndex',
    components: {
      LazyHydrate,
    },
    layout: 'organization',
    async asyncData({error, $cachedStrapi}) {
      const page = await $cachedStrapi
        .findOne('pages', 'home-jobanbieter')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      if (!scopeHelper(page, process.env.SCOPE_ORGANIZATION)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }

      const metaData = Object.freeze(page && page.meta ? page.meta : {});

      const sections = Object.freeze(
        await mapSectionComponents(page.sections, async function (section) {
          switch (section.component) {
            case 'SectionSeoContent':
              if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        })
      );

      return {
        metaData,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
  };
